// extracted by mini-css-extract-plugin
export default {"container":"SpecifyOrder_container__bvrYa","textareaContainer":"SpecifyOrder_textareaContainer__yj2kI","label":"SpecifyOrder_label__LqvXL","textarea":"SpecifyOrder_textarea__yPWJO"};